import PageHead from "../Head";
import { withGuestSSR } from "@/lib/withGuestSSR";

import Context from "@/context/Context";
import Login from "@/my_components/_Login/Login";

const LoginPage = () => {
  return (
      <Context>
        <PageHead title="Sign In | SmartTech Academy" />

        <Login />
      </Context>
  );
};

export default LoginPage;

export const getServerSideProps = withGuestSSR();
